//@ts-nocheck

import { animate } from "../components/animeComponents";

window.addEventListener("load", () => {
  animate();
  ShowMoreVideo();
});

const ShowMoreVideo = () => {
  const moreBtn = document.querySelector(".linktree__btn");
  const AllCard = document.querySelectorAll(
    ".lt-gallery__main-videos-box .lt-gallery__main-video"
  );

  if (moreBtn) {
    moreBtn.addEventListener("click", () => {
      AllCard.forEach((video, index) => {
        if (index > 5) video.classList.add("lt-gallery__main-video--show");
      });

      btnMore(AllCard, moreBtn);
    });
  }
};

const btnMore = (cards, btn) => {
  btn.classList.add("linktree__btn-disabled");
};
